var _rect, _rect2, _rect3, _rect4, _path, _line, _line2, _ellipse, _ellipse2, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinkCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 454,
    viewBox: "0 0 542 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 153.05,
    width: 397,
    height: 200.398,
    fill: "#B86636"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 168.079,
    width: 377,
    height: 47.0934,
    fill: "#E1976D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 221.185,
    width: 377,
    height: 116.231,
    fill: "#E1976D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 128,
    width: 426,
    height: 25.0497,
    fill: "#C87749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 353.447H470L484 380H64L73 353.447Z",
    fill: "#C87749"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 221.185,
    x2: 264,
    y2: 337.415,
    stroke: "#C87749",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 168.079,
    x2: 264,
    y2: 216.175,
    stroke: "#C87749",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.5,
    cy: 275.793,
    rx: 7.5,
    ry: 7.51491,
    fill: "#F4CEB8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.5,
    cy: 276.795,
    rx: 7.5,
    ry: 7.51491,
    fill: "#F4CEB8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 186,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#984B20"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 184,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#984B20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinkCabinet);
export default __webpack_public_path__ + "static/media/sink_cabinet.0ebbbe13e288fc62012a7f066eb3d8cd.svg";
export { ForwardRef as ReactComponent };